/* @flow */
// typecheck: ignore file
import React from 'react';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Tooltip from 'components/Tooltip.jsx';

/* Tooltip Trigger.
 * This is a small & simple wrapper around
 * LayerTrigger to write tooltip trigger with ease.
 * (A Tooltip is just a Layer that show on hover with some delay)
 *
 * <TooltipTrigger tooltip="howdy?">
 *   <Button>click me</Button>
 * <TooltipTrigger/>
 *
 * <TooltipTrigger tooltip={<Tooltip color="brand">howdy?<Tooltip/>}>
 *   <Button>click me</Button>
 * <TooltipTrigger/>
 */
class TooltipTrigger extends React.Component {
  props: {
    tooltip: string | React$Element<*>, /* Tooltip only fixme */
    placement?: 'top' | 'right' | 'bottom' | 'left',
    alignment?: 'top' | 'right' | 'bottom' | 'left',
    children?: React$Element<*>,
  }

  render() {
    const {
      tooltip,
      children,
      placement,
      alignment,
    } = this.props;

    const layer = (() => {
      if (typeof tooltip === 'string') {
        return <Tooltip>{tooltip}</Tooltip>;
      } else {
        return tooltip;
      }
    })();

    return (
      <LayerTrigger
        trigger={['hover', 'focus']}
        layer={layer}
        placement={placement}
        alignment={alignment}
        delayShow={400}>
        {children}
      </LayerTrigger>
    );
  }
}

export default TooltipTrigger;



// WEBPACK FOOTER //
// ./src/components/TooltipTrigger.jsx